const getFoldersToDelete = (initialFolders, currentFolders) => {
  const initialFolderIds = initialFolders.map((f) => f.id);
  const currentFolderIdsSet = new Set(currentFolders.map((f) => f.id));

  return new Set(initialFolderIds.filter((id) => !currentFolderIdsSet.has(id)));
};

export default getFoldersToDelete;
